
import { destroy, get, getOne, post, put } from "../apis/httpClient"

export const pagingBanner=(params)=>get('/api/v1/banner/paging',params)
export const detailBanner=(query)=>getOne(`/api/v1/banner/detail/${query}`)
export const updateBanner=(body)=>put(`/api/v1/banner/update`,body)
export const createBanner=(body)=>post(`/api/v1/banner/create`,body)
export const deleteBanner=(body)=>destroy(`/api/v1/banner/delete`,body)
export const loadFunc=(path) => get(path)
